export const LABEL = 'Enable text selection for questions';
export const MESSAGE = "Having this enabled will allow students to select the question's text. This would mean that they can copy the question and search for it online. If you wish to restrict them from copying the question, disable this.";
